import backofficeUsersQuery from "@/graphql/queries/backofficeUsersQuery.graphql";
import { graphQLClient } from "@/utils/graphQLClient";

export default {
  namespaced: false,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    async requestAdmins() {
      let { backofficeUsers } = await graphQLClient.request(
        backofficeUsersQuery
      );

      return backofficeUsers;
    },
  },
};
